import React from 'react';
import ProductCardImage from './ProductCardImage';
import { translate } from '../Services/translation';
const ProductCard = (product) => {
  return (
    <div
      className="product__card"
    >
      <ProductCardImage product={product} hideProductTags={false} />
      <div className="product__info">
        <a
          className="product__title-wrapper"
          href={product.url}
          title={product.name}
        >
          <h3 className="product__name">
            {product.name}
          </h3>
          <span>{product.category}</span>
        </a>
        <div
          className="product__price"
        >
          {product.lowestPrice?.formattedCampaignPrice ? (
            <>
              <span className="product-page__price--campaign-price">
                {product.lowestPrice?.formattedCampaignPrice}
              </span>
              <span className="[ product-page__price--original ] [ color-grey-900 text-small ]">
                {product.lowestPrice?.formattedPrice}
              </span>
            </>
          ) : (
            <span className="text-medium bold">
              {product.lowestPrice
                ? `${translate('quicksearch.price.lowestprice')} ${
                    product.lowestPrice.formattedCampaignPrice
                      ? product.lowestPrice.formattedCampaignPrice
                      : product.lowestPrice.formattedPrice
                  }`
                : product.price?.formattedPrice}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
export default ProductCard;
